import classNames from 'classnames';
import { FunctionComponent, MouseEventHandler } from 'react';

import { PropsWithClassname } from '@/app/types';

interface MenuBurgerProps extends PropsWithClassname {
  onClick: MouseEventHandler;
  isOpen: boolean;
}

const MenuBurger: FunctionComponent<MenuBurgerProps> = ({ onClick, isOpen, className }) => {
  return (
    <button
      className={classNames(
        className,
        'relative w-[24px] h-[24px] flex flex-col justify-between items-stretch py-[5px] px-[3px]',
      )}
      onClick={onClick}
    >
      <div
        className={classNames('w-[18px] h-[2px] rounded-sm bg-neutral-dark transition-all absolute top-1/2')}
        style={{
          transform: isOpen ? 'rotate(-45deg) translate(0, 0px)' : 'rotate(0deg) translate(0, -6px)',
        }}
      />
      <div
        className={classNames('w-[18px] h-[2px] rounded-sm bg-neutral-dark transition-all absolute top-1/2', {
          hidden: isOpen,
        })}
      />
      <div
        className={classNames('w-[18px] h-[2px] rounded-sm bg-neutral-dark transition-all absolute top-1/2')}
        style={{
          transform: isOpen ? 'rotate(45deg) translate(0, 0px)' : 'rotate(0deg) translate(0, 6px)',
        }}
      />
    </button>
  );
};

export default MenuBurger;
